import { cn } from '@crm/ui';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { SectionScreen, TILE_ATIVO, TILE_NORMAL, TileButton, TileLink } from './mobile-nav';
import { type NavSection, useNavSections, useQuickActions } from './navigation';

/** A secao cujas telas ficam soltas no painel, sem um passo a mais. */
const SEM_SUBMENU = 'Operacao';

/**
 * O atalho e um alvo grande: icone em cima, nome embaixo, todos do mesmo
 * tamanho. So no desktop - no celular quem faz esse papel sao os cartoes das
 * secoes, logo abaixo.
 */
const ATALHO = cn(
  'flex h-24 flex-col items-center justify-center gap-2 rounded-md border px-2 text-center text-sm font-medium',
  'transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:bg-primary/[0.06]',
  'hover:shadow-[0_4px_12px_-4px_rgb(0_0_0/0.18)] active:translate-y-0 active:shadow-none',
);

function Atalhos() {
  const atalhos = useQuickActions();

  if (atalhos.length === 0) return null;

  return (
    <nav className="hidden gap-2 sm:grid sm:grid-cols-4 lg:grid-cols-7" aria-label="Atalhos">
      {atalhos.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => cn(ATALHO, isActive ? TILE_ATIVO : TILE_NORMAL)}
        >
          <item.icon className="h-7 w-7 text-primary" aria-hidden />
          <span className="line-clamp-2 leading-tight">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export function QuickActions() {
  const sections = useNavSections();
  const [aberta, setAberta] = useState<NavSection | null>(null);

  if (sections.length === 0) return null;

  return (
    <>
      <Atalhos />

      <section className="grid grid-cols-2 gap-3 sm:hidden" aria-label="Menus">
        {sections.flatMap((section) =>
          section.to
            ? []
            : section.title === SEM_SUBMENU
              ? section.items.map((item) => <TileLink key={item.to} item={item} />)
              : [
                  <TileButton
                    key={section.title}
                    icon={section.icon}
                    label={section.title}
                    onClick={() => setAberta(section)}
                  />,
                ],
        )}
      </section>

      {aberta ? (
        <SectionScreen
          section={aberta}
          onBack={() => setAberta(null)}
          onNavigate={() => setAberta(null)}
        />
      ) : null}
    </>
  );
}
